import { useVariant } from '../context/VariantContext';

export default function Howto() {
  const { howto } = useVariant();
  return (
    <section className="lp__howto" id="howto">
      <img
        className="lp__howto-round"
        src="/lp-img/round_bottom_white.svg"
        alt=""
        loading="lazy"
      />
      <p className="lp__howto-en">Howto</p>
      <h2 className="lp__howto-heading">
        {howto.heading}
      </h2>
      <div className="lp__howto-list">
        {howto.cards.map((card) => (
          <div
            className="lp__howto-card"
            key={card.number}
          >
            <div
              className="lp__howto-card__accent"
              style={{
                backgroundColor: card.color,
              }}
            />
            <div className="lp__howto-card__content">
              <div className="lp__howto-card__header">
                <div className="lp__howto-card__heading">
                  <p className="lp__howto-card__number">
                    {card.number}
                  </p>
                  <h3 className="lp__howto-card__title">
                    {card.title}
                  </h3>
                </div>
                <div className="lp__howto-card__icon">
                  <img
                    src={card.icon}
                    alt=""
                    loading="lazy"
                  />
                </div>
              </div>
              <p className="lp__howto-card__desc">
                {card.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
